import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { BusinessSchema } from './business-schema'
import { Navbar } from './navbar'
import { Footer } from './footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <>
            <BusinessSchema />
            <Navbar />
            <main>{children}</main>
            <Footer />
        </>
    )
}
